module.exports = __webpack_public_path__ + "static/media/clickedBookmark.22e9b627.png";